<template>
  <div class="request-form">

    <div class="request-form-inner" :class="{submitting: submitting}">
      <form
              id="app"
              @submit="submit($event)"
              action=""
              method="post"
              novalidate="true">

        <div class="form-group" :class="{'has-error': $v.name.$error}">
          <label for="name">Name</label>
          <input id="name"
                 class="form-control"
                 v-model="$v.name.$model"
                 type="text"
                 name="name">
          <span class="help-block" v-if="!$v.name.required">Field is required.</span>
          <span class="help-block" v-if="!$v.name.minLength">Name must have at least {{$v.name.$params.minLength.min}} letters.</span>
        </div>

        <div class="form-group" :class="{'has-error': $v.email.$error}">
          <label for="email">Email</label>
          <input id="email"
                 class="form-control"
                 v-model="$v.email.$model"
                 type="email"
                 name="email">
          <span class="help-block" v-if="!$v.email.required">Field is required.</span>
          <span class="help-block" v-if="!$v.email.email">Email must be properly formatted.</span>
        </div>

        <div class="form-group" :class="{'has-error': $v.remarks.$error}">
          <label for="remarks">Remarks</label>
          <textarea id="remarks"
                    class="form-control"
                    v-model="$v.remarks.$model"
                    name="remarks"></textarea>
          <span class="help-block" v-if="!$v.remarks.required">Field is required.</span>
          <span class="help-block" v-if="!$v.remarks.minLength">Remarks must have at least {{$v.remarks.$params.minLength.min}} letters.</span>
        </div>

        <div class="form-group">
          <input class="btn"
                 type="submit"
                 value="Submit">
        </div>

      </form>
    </div>




  </div>
</template>

<script>
import { required, minLength, email } from 'vuelidate/lib/validators';
import NProgress from 'nprogress';
import '../../node_modules/nprogress/nprogress.css';

export default {
    name: 'RequestForm',
    data: function(){

        return {
            result: {},
            name: null,
            email: null,
            remarks: null,
            submitting: false
        }

    },
    validations: {
        name: {
            required,
            minLength: minLength(2)
        },
        email: {
            required,
            email
        },
        remarks: {
            required,
            minLength: minLength(10)
        },
    },
    computed: {
        image() {
            return this.$store.state.image;
        }
    },
    watch:{
      result(){
          if(this.result.success){
              this.$store.dispatch('next');
          }
      },
      submitting(){
          if(this.submitting){
              NProgress.start();
          }else{
              NProgress.done();
          }
      }
    },
    methods: {
        submit(event){

            event.preventDefault();

            this.$v.$touch();

            if(!this.$v.$invalid){

                const data = new FormData();

                data.append('image', this.image, 'image.png');
                data.append('name', this.name);
                data.append('email', this.email);
                data.append('remarks', this.remarks);


                this.submitting = true;
                this.$api.post('/tcsubmit?XDEBUG_SESSION_START=phpstorm', data).then((result) => {
                    this.result = result.data;
                    this.submitting = false;
                });

            }
        }
    },
    mounted(){
        NProgress.configure({
            parent: '.request-form',
            template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div><div class="msg">Submitting</div>'
        });
    },
    beforeDestroy(){
        NProgress.done();
        NProgress.remove();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .request-form{
    padding: 15px 15px 5px 15px;
    background-color: #fff;
    border-radius: 5px;
  }

  .request-form-inner{
    transition: opacity 0.5s ease;
  }

  label{
    font-weight: normal;
  }

  .help-block{
    font-size: 12px;
    display: none;
  }

  .has-error .help-block{
    display: block;
  }

  .btn{
    background-color: cornflowerblue;

    &, &:hover, &:focus, &:active{
      color: #fff;
    }
  }

  .submitting{
    opacity: 0.2;
  }

  /deep/ #nprogress{
    /*position: absolute;*/
    /*top: 50%;*/
    /*left: 50px;*/
    /*right: 50px;*/
    /*overflow: hidden;*/
    /*height: 35px;*/

    .msg{
      font-weight: bold;
      color: #2499db;
      position: absolute;
      top: 13px;
      right: 50px;
    }
  }
</style>
